module.exports = __webpack_public_path__ + "img/pic9.54bd9743.jpg";